import React from 'react'
import { Flex, Heading, Text } from 'theme-ui'
import CloudinaryImage from '../../General/CloudinaryImage'
import Shout from '../../Shout/v1/Index'
import LinkSelector from '../../Links/LinkSelector'

export default function HeroContent({
  logoHero,
  titles,
  subtitles,
  texts,
  ctaNames,
  ctaLinks,
  city,
  imageBaseUrl,
  isMultiLocationSite,
  imagePrefix,
  locationIndex,
  variantName,
  shoutData,
  shoutStyles,
}) {
  return (
    <Flex className='hero_content_container' variant={`${variantName}.content`}>
      {logoHero && (
        <CloudinaryImage
          variant={`${variantName}.logoHero`}
          className='logoHero'
          imageBaseUrl={imageBaseUrl}
          imagePrefix={imagePrefix}
        />
      )}

      {titles && (
        <Heading variant={`${variantName}.title`} as='h3' className='title'>
          {titles[locationIndex]}
        </Heading>
      )}
      {subtitles && (
        <Heading
          variant={`${variantName}.subtitle`}
          as='h4'
          className='subtitle'>
          {subtitles[locationIndex]}
        </Heading>
      )}
      {texts && (
        <Text variant={`${variantName}.text`} as='p' className='text'>
          {texts[locationIndex]}
        </Text>
      )}

      {shoutData?.shout && (
        <Shout
          shoutData={shoutData}
          variantName={`${variantName}.shoutWidget`}
          sx={{
            ...shoutStyles,
          }}
        />
      )}

      {ctaNames && ctaLinks && (
        <LinkSelector
          variant={`${variantName}`}
          ctaName={ctaNames[locationIndex]}
          ctaLink={ctaLinks[locationIndex]}
          isMultiLocationSite={isMultiLocationSite}
          city={city}
        />
      )}
    </Flex>
  )
}
